import './style.css';
import ReactDOM from 'react-dom/client';
import React, { useEffect, useState } from 'react';
import { Canvas, useThree } from '@react-three/fiber';
import Experience from './Experience.jsx';

const root = ReactDOM.createRoot(document.querySelector('#root'));

const DynamicCamera = () => {
  const { camera } = useThree();
  const [fov, setFov] = useState(camera.fov);

  useEffect(() => {
    const updateFov = () => {
      if (window.innerWidth <= 420) {
        setFov(120);
      } else if (window.innerWidth <= 768) {
        setFov(100);
      } else if (window.innerWidth <= 999) {
        setFov(60);
      } else {
        setFov(45);
      }
    };

    updateFov(); // Set initial fov based on current viewport size
    window.addEventListener('resize', updateFov);

    return () => window.removeEventListener('resize', updateFov);
  }, []);

  useEffect(() => {
    camera.fov = fov;
    camera.updateProjectionMatrix(); // Ensure the camera updates with the new fov
  }, [fov, camera]);

  return null; // This component only manages the camera, no visual output
};

const App = () => {
  return (
    <Canvas
      className="r3f"
      camera={{
        fov: 45,
        near: 0.1,
        far: 2000,
        position: [-3, 1.5, 4],
      }}
    >
      <DynamicCamera />
      <Experience />
    </Canvas>
  );
};

root.render(<App />);
